import { ProjectMilestone } from "@remi/types/project-milestones";

import { hasCapability, type User } from "../base";

export const projectMilestones = {
  viewAssignmentMilestone: (user: User) => hasCapability(user, "projectMilestones.viewAssignmentMilestone"),

  viewAdvancedFilters: (user: User) => hasCapability(user, "projectMilestones.viewAdvancedFilters"),

  /**
   * Get milestones that the user is allowed to see
   */
  getVisibleMilestones: (user: User, allMilestones: readonly ProjectMilestone[]) => {
    if (projectMilestones.viewAssignmentMilestone(user)) {
      return allMilestones;
    }
    return allMilestones.filter((milestone) => milestone !== ProjectMilestone.ASSIGNMENT);
  },
};
